import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#050510] text-white" data-testid="terms-page">
      <SEO title="Terms" description="Terms of use for the BRep platform — customers and coaches." path="/terms" />
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-24">
        <Link to="/" className="text-[11px] tracking-[0.3em] uppercase text-white/60 hover:text-[#2A5BFF] transition-colors" data-testid="terms-back">← Back</Link>
        <h1 className="font-anton uppercase text-5xl md:text-6xl mt-8">Terms</h1>
        <p className="mt-6 text-white/60 leading-relaxed">
          These terms apply to your use of BRep. By using the platform you agree to be bound by them.
        </p>
        <h2 className="font-anton uppercase text-2xl mt-10">Services</h2>
        <p className="mt-3 text-white/60">BRep is a marketplace that connects customers with independent, qualified coaches for one-off fitness services. Every service listing details what's included and turnaround times.</p>
        <h2 className="font-anton uppercase text-2xl mt-10">Coaches</h2>
        <p className="mt-3 text-white/60">Coach listings are subject to review, verification of qualifications, and ongoing quality standards. Coaches are independent contractors — not employees of BRep.</p>
        <h2 className="font-anton uppercase text-2xl mt-10">Payments &amp; refunds</h2>
        <p className="mt-3 text-white/60">You pay per service. If a coach has not yet started work, you can request a refund. Once work has begun, refunds are assessed case-by-case and we err on the side of the client.</p>
        <h2 className="font-anton uppercase text-2xl mt-10">Changes</h2>
        <p className="mt-3 text-white/60">We may update these terms from time to time. Continued use of BRep means you accept the updated terms.</p>
      </div>
    </div>
  );
}
